var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "majesticons:mail-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.73177 12.4046L14.7318 16.4046C15.2047 16.7833 15.7926 16.9896 16.3984 16.9896C17.0043 16.9896 17.5921 16.7833 18.0651 16.4046L23.0651 12.4046M28.3984 23.0713V9.73796C28.3984 9.03071 28.1175 8.35243 27.6174 7.85234C27.1173 7.35224 26.439 7.07129 25.7318 7.07129H7.0651C6.35786 7.07129 5.67958 7.35224 5.17949 7.85234C4.67939 8.35243 4.39844 9.03071 4.39844 9.73796V23.0713C4.39844 23.7785 4.67939 24.4568 5.17949 24.9569C5.67958 25.457 6.35786 25.738 7.0651 25.738H25.7318C26.439 25.738 27.1173 25.457 27.6174 24.9569C28.1175 24.4568 28.3984 23.7785 28.3984 23.0713Z",
    stroke: "#0074FF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlue);
export default __webpack_public_path__ + "static/media/MailBlue.ad06a48ce8dd5c84449ba14cddcdae00.svg";
export { ForwardRef as ReactComponent };